
/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { OfferingsPage, PolicyInfoPage, PolicyDetailsPage, LocationsPage, DeclarationPage, RiskAnalysisPage, SuccessPage} from 'premier-capability-policyjob-react';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
import HoleInOnePage from './pages/HoleInOne/HoleInOnePage';
import QuotePage from './pages/Quote/QuotePage';
import EventLiabilityPage from './pages/EventLiability/EventLiabilityPage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierOfferingsPage : { component: 'PremierOfferingsPage'},
        PremierSCPolicyDetailsPage: { component: 'PremierSCPolicyDetailsPage'},
        PremierSCLocationsPage: { component: 'PremierSCLocationsPage'},
        PremierSCEventLiabilityPage: { component: 'PremierSCEventLiabilityPage'},
        PremierSCLiabilityCoveragesPage: { component: 'PremierSCLiabilityCoveragesPage' },
        PremierSCQuotePage: { component: 'PremierSCQuotePage' },
        PremierSCPolicyInfoPage: { component: 'PremierSCPolicyInfoPage' },
        PremierSCSuccessPage: { component: 'PremierSCSuccessPage' },
        PremierSCDeclarationPage: { component: 'PremierSCDeclarationPage'},
        PremierSCRiskAnalysisPage: { component: 'PremierSCRiskAnalysisPage'},
        PremierSCHoleInOnePage: { component: 'PremierSCHoleInOnePage'},
    },
    {
        // wizard pages
        PremierOfferingsPage: OfferingsPage,
        PremierSCPolicyDetailsPage: PolicyDetailsPage,
        PremierSCPolicyInfoPage: PolicyInfoPage,
        PremierSCLocationsPage: LocationsPage,
        PremierSCEventLiabilityPage: EventLiabilityPage,
        PremierSCHoleInOnePage: HoleInOnePage,
        PremierSCLiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierSCQuotePage: QuotePage,
        PremierSCSuccessPage: SuccessPage,
        PremierSCDeclarationPage : DeclarationPage,
        PremierSCRiskAnalysisPage: RiskAnalysisPage,
    }

    
);
 
export { CodegenWizard, CodegenContext };
